import { Typography } from '@mui/material'
import { formatDate, formatStringDate } from '../../utils/Utils'

interface Props {
  data: {
    lastDownloaded: any
  }
}

const SitemapDate = ({ data }: Props) => {

  return (
    <Typography>{formatDate(data.lastDownloaded)}</Typography>
  )
}

export default SitemapDate;